import { storableError } from '../../util/errors';
import * as log from '../../util/log';
import { userTypeOf } from '../../util/userType';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { setInitialValues as setInitialValuesForPaymentMethods } from '../../ducks/paymentMethods.duck';
import { createCheckoutSession, jobRFPSlots, integrityCheckCredits } from '../../util/api';

// ================ Action types ================ //

export const SETUP_INTENT_REQUEST = 'app/PaymentMethodsPage/SETUP_INTENT_REQUEST';
export const SETUP_INTENT_SUCCESS = 'app/PaymentMethodsPage/SETUP_INTENT_SUCCESS';
export const SETUP_INTENT_ERROR = 'app/PaymentMethodsPage/SETUP_INTENT_ERROR';

export const STRIPE_CUSTOMER_REQUEST = 'app/PaymentMethodsPage/STRIPE_CUSTOMER_REQUEST';
export const STRIPE_CUSTOMER_SUCCESS = 'app/PaymentMethodsPage/STRIPE_CUSTOMER_SUCCESS';
export const STRIPE_CUSTOMER_ERROR = 'app/PaymentMethodsPage/STRIPE_CUSTOMER_ERROR';

export const BUY_MESSAGE_PACK_REQUEST = 'app/PaymentMethodsPage/BUY_MESSAGE_PACK_REQUEST';
export const BUY_MESSAGE_PACK_SUCCESS = 'app/PaymentMethodsPage/BUY_MESSAGE_PACK_SUCCESS';
export const BUY_MESSAGE_PACK_ERROR = 'app/PaymentMethodsPage/BUY_MESSAGE_PACK_ERROR';


export const BUY_JOB_SLOTS_REQUEST = 'app/PaymentMethodsPage/BUY_JOB_SLOTS_REQUEST';
export const BUY_JOB_SLOTS_SUCCESS = 'app/PaymentMethodsPage/BUY_JOB_SLOTS_SUCCESS';
export const BUY_JOB_SLOTS_ERROR = 'app/PaymentMethodsPage/BUY_JOB_SLOTS_ERROR';

export const BUY_RFP_SLOTS_REQUEST = 'app/PaymentMethodsPage/BUY_RFP_SLOTS_REQUEST';
export const BUY_RFP_SLOTS_SUCCESS = 'app/PaymentMethodsPage/BUY_RFP_SLOTS_SUCCESS';
export const BUY_RFP_SLOTS_ERROR = 'app/PaymentMethodsPage/BUY_RFP_SLOTS_ERROR';

export const BUY_INTEGRITY_CREDITS_REQUEST = 'app/PaymentMethodsPage/BUY_INTEGRITY_CREDITS_REQUEST';
export const BUY_INTEGRITY_CREDITS_SUCCESS = 'app/PaymentMethodsPage/BUY_INTEGRITY_CREDITS_SUCCESS';
export const BUY_INTEGRITY_CREDITS_ERROR = 'app/PaymentMethodsPage/BUY_INTEGRITY_CREDITS_ERROR';

// SkillFit Check credit add-on purchase (mirrors integrity, kept distinct).
export const BUY_SKILLFIT_CREDITS_REQUEST = 'app/PaymentMethodsPage/BUY_SKILLFIT_CREDITS_REQUEST';
export const BUY_SKILLFIT_CREDITS_SUCCESS = 'app/PaymentMethodsPage/BUY_SKILLFIT_CREDITS_SUCCESS';
export const BUY_SKILLFIT_CREDITS_ERROR = 'app/PaymentMethodsPage/BUY_SKILLFIT_CREDITS_ERROR';

// ================ Reducer ================ //

const initialState = {
  setupIntentInProgress: false,
  setupIntentError: null,
  setupIntent: null,
  stripeCustomerFetched: false,
  stripeCustomerFetchError: null,
  buyMessagePackInProgress: false,
  buyMessagePackError: null,
  buyMessagePackSuccess: null,
  buyJobSlotsInProgress: false,
  buyJobSlotsError: null,
  buyJobSlotsSuccess: null,
  buyRFPSlotsInProgress: false,
  buyRFPSlotsError: null,
  buyRFPSlotsSuccess: null,
  buyIntegrityCreditsInProgress: false,
  buyIntegrityCreditsError: null,
  buyIntegrityCreditsSuccess: null,
  buySkillFitCreditsInProgress: false,
  buySkillFitCreditsError: null,
  buySkillFitCreditsSuccess: null,
};

export default function payoutMethodsPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SETUP_INTENT_REQUEST:
      return { ...state, setupIntentInProgress: true, setupIntentError: null };
    case SETUP_INTENT_SUCCESS:
      return {
        ...state,
        setupIntentInProgress: false,
        setupIntentError: null,
        setupIntent: payload,
      };
    case SETUP_INTENT_ERROR:
      return { ...state, setupIntentInProgress: false, setupIntentError: null };
    case STRIPE_CUSTOMER_REQUEST:
      return { ...state, stripeCustomerFetched: false };
    case STRIPE_CUSTOMER_SUCCESS:
      return { ...state, stripeCustomerFetched: true };
    case STRIPE_CUSTOMER_ERROR:
      return { ...state, stripeCustomerFetchError: payload };
    
    case BUY_MESSAGE_PACK_REQUEST:
      return { ...state, buyMessagePackInProgress: true, buyMessagePackError: null };
    case BUY_MESSAGE_PACK_SUCCESS:
      const { url } = payload;
      window.location.href = url;

      return {
        ...state,
        buyMessagePackInProgress: false,
        buyMessagePackError: null,
        buyMessagePackSuccess: payload,
      };
    case BUY_MESSAGE_PACK_ERROR:
      return { ...state, buyMessagePackInProgress: false, buyMessagePackError: payload };

    case BUY_JOB_SLOTS_REQUEST:
      return { ...state, buyJobSlotsInProgress: true, buyJobSlotsError: null };
    case BUY_JOB_SLOTS_SUCCESS:
      const { url: jobSlotsUrl } = payload;
      window.location.href = jobSlotsUrl;

      return {
        ...state,
        buyJobSlotsInProgress: false,
        buyJobSlotsError: null,
        buyJobSlotsSuccess: payload,
      };
    case BUY_JOB_SLOTS_ERROR:
      return { ...state, buyJobSlotsInProgress: false, buyJobSlotsError: payload };

    case BUY_RFP_SLOTS_REQUEST:
      return { ...state, buyRFPSlotsInProgress: true, buyRFPSlotsError: null };
    case BUY_RFP_SLOTS_SUCCESS:
      const { url: rfpSlotsUrl } = payload;
      window.location.href = rfpSlotsUrl;

      return {
        ...state,
        buyRFPSlotsInProgress: false,
        buyRFPSlotsError: null,
        buyRFPSlotsSuccess: payload,
      };
    case BUY_RFP_SLOTS_ERROR:
      return { ...state, buyRFPSlotsInProgress: false, buyRFPSlotsError: payload };

    case BUY_INTEGRITY_CREDITS_REQUEST:
      return { ...state, buyIntegrityCreditsInProgress: true, buyIntegrityCreditsError: null };
    case BUY_INTEGRITY_CREDITS_SUCCESS:
      const { url: integrityCreditsUrl } = payload;
      window.location.href = integrityCreditsUrl;

      return {
        ...state,
        buyIntegrityCreditsInProgress: false,
        buyIntegrityCreditsError: null,
        buyIntegrityCreditsSuccess: payload,
      };
    case BUY_INTEGRITY_CREDITS_ERROR:
      return { ...state, buyIntegrityCreditsInProgress: false, buyIntegrityCreditsError: payload };

    case BUY_SKILLFIT_CREDITS_REQUEST:
      return { ...state, buySkillFitCreditsInProgress: true, buySkillFitCreditsError: null };
    case BUY_SKILLFIT_CREDITS_SUCCESS:
      const { url: skillFitCreditsUrl } = payload;
      window.location.href = skillFitCreditsUrl;

      return {
        ...state,
        buySkillFitCreditsInProgress: false,
        buySkillFitCreditsError: null,
        buySkillFitCreditsSuccess: payload,
      };
    case BUY_SKILLFIT_CREDITS_ERROR:
      return { ...state, buySkillFitCreditsInProgress: false, buySkillFitCreditsError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const setupIntentRequest = () => ({ type: SETUP_INTENT_REQUEST });
export const setupIntentSuccess = () => ({ type: SETUP_INTENT_SUCCESS });
export const setupIntentError = e => ({
  type: SETUP_INTENT_ERROR,
  error: true,
  payload: e,
});

export const stripeCustomerRequest = () => ({ type: STRIPE_CUSTOMER_REQUEST });
export const stripeCustomerSuccess = () => ({ type: STRIPE_CUSTOMER_SUCCESS });
export const stripeCustomerError = e => ({
  type: STRIPE_CUSTOMER_ERROR,
  error: true,
  payload: e,
});

export const buyMessagePackRequest = () => ({ type: BUY_MESSAGE_PACK_REQUEST });
export const buyMessagePackSuccess = (response) => ({ 
  type: BUY_MESSAGE_PACK_SUCCESS,
  payload: response,
});
export const buyMessagePackError = e => ({
  type: BUY_MESSAGE_PACK_ERROR,
  error: true,
  payload: e,
});

export const buyJobSlotsRequest = () => ({ type: BUY_JOB_SLOTS_REQUEST });
export const buyJobSlotsSuccess = (response) => ({
  type: BUY_JOB_SLOTS_SUCCESS,
  payload: response,
});
export const buyJobSlotsError = e => ({
  type: BUY_JOB_SLOTS_ERROR,
  error: true,
  payload: e,
});

export const buyRFPSlotsRequest = () => ({ type: BUY_RFP_SLOTS_REQUEST });
export const buyRFPSlotsSuccess = (response) => ({
  type: BUY_RFP_SLOTS_SUCCESS,
  payload: response,
});
export const buyRFPSlotsError = e => ({
  type: BUY_RFP_SLOTS_ERROR,
  error: true,
  payload: e,
});

export const buyIntegrityCreditsRequest = () => ({ type: BUY_INTEGRITY_CREDITS_REQUEST });
export const buyIntegrityCreditsSuccess = (response) => ({
  type: BUY_INTEGRITY_CREDITS_SUCCESS,
  payload: response,
});
export const buyIntegrityCreditsError = e => ({
  type: BUY_INTEGRITY_CREDITS_ERROR,
  error: true,
  payload: e,
});

export const buySkillFitCreditsRequest = () => ({ type: BUY_SKILLFIT_CREDITS_REQUEST });
export const buySkillFitCreditsSuccess = (response) => ({
  type: BUY_SKILLFIT_CREDITS_SUCCESS,
  payload: response,
});
export const buySkillFitCreditsError = e => ({
  type: BUY_SKILLFIT_CREDITS_ERROR,
  error: true,
  payload: e,
});

// ================ Helpers ================ //

// Sum of non-expired `availableCredits` across credit lots. Shared shape between
// Integrity and SkillFit credit lots; used to derive the balance shown on the page.
export const sumAvailableCredits = (credits) =>
  (credits || []).reduce((sum, credit) => {
    if (credit && !credit.expired && new Date(credit.expiry) > new Date()) {
      return sum + (credit.availableCredits || 0);
    }
    return sum;
  }, 0);

// ================ Thunks ================ //

export const createStripeSetupIntent = () => (dispatch, getState, sdk) => {
  dispatch(setupIntentRequest());
  return sdk.stripeSetupIntents
    .create()
    .then(response => {
      const setupIntent = response.data.data;
      dispatch(setupIntentSuccess(setupIntent));
      return setupIntent;
    })
    .catch(e => {
      const error = storableError(e);
      log.error(error, 'create-setup-intent-failed');
      dispatch(setupIntentError(error));
      return { createStripeSetupIntentSuccess: false };
    });
};

export const stripeCustomer = () => (dispatch, getState, sdk) => {
  dispatch(stripeCustomerRequest());
  const fetchCurrentUserOptions = {
    callParams: { include: ['stripeCustomer.defaultPaymentMethod'] },
    updateHasListings: false,
    updateNotifications: false,
    enforce: true,
  };

  return dispatch(fetchCurrentUser(fetchCurrentUserOptions))
    .then(response => {
      dispatch(stripeCustomerSuccess());
    })
    .catch(e => {
      const error = storableError(e);
      log.error(error, 'fetch-stripe-customer-failed');
      dispatch(stripeCustomerError(error));
    });
};

export const loadData = () => (dispatch, getState, sdk) => {
  dispatch(setInitialValuesForPaymentMethods());

  return dispatch(stripeCustomer());
};

export const buyMessagesPack = (priceId, quantity=1, type='messagePack') => async (dispatch, getState, sdk) => {
  dispatch(buyMessagePackRequest());
  
  const state = getState();
  const currentUser = state.user?.currentUser;
  const profileListing = state.user?.profileListing;
  
  const profileListingId = currentUser?.attributes?.profile?.publicData?.profileListingId ||
                    currentUser?.attributes?.profile?.publicData?.firstListingId;

  let email = null;
  let adminId = '';

  if (!profileListingId) {
    return;
  }

  if (userTypeOf(currentUser) === 'candidate') {
    adminId = currentUser?.id?.uuid;
    email = currentUser?.attributes?.email;
  } else {
    // let profileListing = await sdk.listings.show({ id: profileListingId });
    // profileListing = profileListing?.data?.data;
    
    email = currentUser?.attributes?.email;
    
    adminId = profileListing?.attributes?.publicData?.adminId;
    // if (adminId) {
    //   const adminUserResponse = await getUserDetails({ userId: adminId });
    //   const adminUser = adminUserResponse?.data?.data;
    //   email = adminUser?.attributes?.email;
    // }
  }

  if (!email) {
    return;
  }

  return createCheckoutSession({ priceId, quantity, type, email, paidBy: adminId, isMessagePack: true })
    .then(response => {
      dispatch(buyMessagePackSuccess(response));
      return response;
    })
    .catch(error => {
      dispatch(buyMessagePackError(error));
    })

};


export const buyJobRFPSlots = (priceId, quantity, type, isJobSlot = true) => async (dispatch, getState, sdk) => {
  if (isJobSlot) {
    dispatch(buyJobSlotsRequest());
  } else {
    dispatch(buyRFPSlotsRequest());
  }

  const state = getState();
  const currentUser = state.user?.currentUser;
  const profileListing = state.user?.profileListing;

  const profileListingId = currentUser?.attributes?.profile?.publicData?.profileListingId ||
                    currentUser?.attributes?.profile?.publicData?.firstListingId;

  let email = null;
  let adminId = '';

  if (!profileListingId) {
    return;
  }

  if (userTypeOf(currentUser) === 'candidate') {
    adminId = currentUser?.id?.uuid;
    email = currentUser?.attributes?.email;
  } else {
    adminId = profileListing?.attributes?.publicData?.adminId;
    email = currentUser?.attributes?.email;
  }

  if (!email) {
    return;
  }

  return createCheckoutSession({
    priceId,
    quantity,
    type: `${type}Slot`,
    email,
    paidBy: adminId,
    isJobRFPSlot: true,
    slotType: type
  })
    .then(response => {
      if (isJobSlot) {
        dispatch(buyJobSlotsSuccess(response));
      } else {
        dispatch(buyRFPSlotsSuccess(response));
      }
      return response;
    })
    .catch(error => {
      if (isJobSlot) {
        dispatch(buyJobSlotsError(error));
      } else {
        dispatch(buyRFPSlotsError(error));
      }
    });
};

export const buyIntegrityCredits = (priceId, quantity = 1) => async (dispatch, getState, sdk) => {
  dispatch(buyIntegrityCreditsRequest());

  const state = getState();
  const currentUser = state.user?.currentUser;
  const profileListing = state.user?.profileListing;

  const profileListingId = currentUser?.attributes?.profile?.publicData?.profileListingId ||
                    currentUser?.attributes?.profile?.publicData?.firstListingId;

  let email = null;
  let adminId = '';

  if (!profileListingId) {
    return;
  }

  if (userTypeOf(currentUser) === 'candidate') {
    adminId = currentUser?.id?.uuid;
    email = currentUser?.attributes?.email;
  } else {
    adminId = profileListing?.attributes?.publicData?.adminId;
    email = currentUser?.attributes?.email;
  }

  if (!email) {
    return;
  }

  return createCheckoutSession({
    priceId,
    quantity,
    type: 'integrityCheckCredits',
    email,
    paidBy: adminId,
    isIntegrityCheckCredits: true,
  })
    .then(response => {
      dispatch(buyIntegrityCreditsSuccess(response));
      return response;
    })
    .catch(error => {
      dispatch(buyIntegrityCreditsError(error));
    });
};

// Purchase additional SkillFit Check credits ($5 = 1 credit) via Stripe Checkout.
// Mirrors buyIntegrityCredits but is kept as a distinct flow with its own flags.
export const buySkillFitCredits = (priceId, quantity = 1) => async (dispatch, getState, sdk) => {
  dispatch(buySkillFitCreditsRequest());

  const state = getState();
  const currentUser = state.user?.currentUser;
  const profileListing = state.user?.profileListing;

  const profileListingId = currentUser?.attributes?.profile?.publicData?.profileListingId ||
                    currentUser?.attributes?.profile?.publicData?.firstListingId;

  let email = null;
  let adminId = '';

  if (!profileListingId) {
    return;
  }

  if (userTypeOf(currentUser) === 'candidate') {
    adminId = currentUser?.id?.uuid;
    email = currentUser?.attributes?.email;
  } else {
    adminId = profileListing?.attributes?.publicData?.adminId;
    email = currentUser?.attributes?.email;
  }

  if (!email) {
    return;
  }

  return createCheckoutSession({
    priceId,
    quantity,
    type: 'skillFitCheckCredits',
    email,
    paidBy: adminId,
    isSkillFitCheckCredits: true,
  })
    .then(response => {
      dispatch(buySkillFitCreditsSuccess(response));
      return response;
    })
    .catch(error => {
      dispatch(buySkillFitCreditsError(error));
    });
};
